module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-228.2a9a203.woff2";